import { Component, inject, ViewChild } from '@angular/core';
import { ServiceDataShareStore } from './service-data-share.store';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ServiceDataShareObject } from '@libs/types/src/services/object-type/service/service-data-share.object';
import { FilterBuilder } from '../../../helper/filter.builder';
import { ServiceDataShareDialogComponent } from './service-data-share-dialog/service-data-share-dialog.component';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-service-data-share',
    templateUrl: './service-data-share.component.html',
    styleUrl: './service-data-share.component.scss',
    providers: [ServiceDataShareStore],
    imports: [
        TranslatePipe,
        CardTableComponent,
        PrimeTemplate,
    ],
})
export class ServiceDataShareComponent {
    protected readonly dialogService = inject(BaseDialogService);
    private readonly confirm = inject(ConfirmBuilder);
    private readonly translate = inject(TranslateService);

    @ViewChild('sharesTable') sharesTable!: TableComponent;

    protected readonly store = inject(ServiceDataShareStore);

    protected columns = [
        {
            name: 'serviceToShare',
            data: (service: any) => service.name,
        },
        { name: 'employmentNames' },
        {
            name: 'onlyMarkedFolders',
            type: TableColumnType.Bool,
        },
        // will be used later
        // {
        //     name: 'onlyRead',
        //     type: TableColumnType.Bool,
        // },
        { name: 'widgets' },
    ];

    constructor() {
        this.store.doOnActions(
            () => this.getShares(),
            'createServiceDataShare', 'updateServiceDataShare', 'deleteServiceDataShare',
        );
    }

    openDialog(share?: ServiceDataShareObject | null) {
        this.dialogService.open(ServiceDataShareDialogComponent, {
            data: { share },
            header: this.translate.instant(share ? 'service.dataShare.edit' : 'service.dataShare.create'),
        });
    }

    protected detail(item?: ServiceDataShareObject) {
        this.openDialog(item);
    }

    protected delete(event: any) {
        this.confirm.confirmDelete(
            () => this.store.api.deleteServiceDataShare({ id: event.item.id }),
            event,
        );
    }

    private async getShares(): Promise<void> {
        if (!this.store.serviceId()) return;

        await this.store.api.getServiceDataShares(FilterBuilder.singlePage({
            serviceId: this.store.serviceId(),
        }));
    }
}
